import { Box, Link, Typography } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import React from "react";
import IMessage from "../../../../interface/IMessage";

const urlRegex: RegExp = /(https?:\/\/[^\s]+)/g;

interface IMessagePart {
  type: "text" | "link";
  value: string;
}

const RenderMessage = ({
  message,
}: {
  message: IMessage;
}): React.JSX.Element => {
  const parts: IMessagePart[] = [];
  let lastIndex: number = 0;
  const linkRegex = new RegExp(urlRegex);
  let matchResult: RegExpExecArray | null;

  // Split the message text into parts based on URLs
  matchResult = linkRegex.exec(message.text);

  while (matchResult !== null) {
    const match = matchResult[0];
    const index = matchResult.index;

    // push the text before the link (if any)
    if (lastIndex < index) {
      parts.push({
        type: "text",
        value: message.text.slice(lastIndex, index),
      });
    }

    // push the link
    parts.push({
      type: "link",
      value: match,
    });

    lastIndex = index + match.length;
    matchResult = linkRegex.exec(message.text);
  }

  // push any remaining text after the last link
  if (lastIndex < message.text.length) {
    parts.push({
      type: "text",
      value: message.text.slice(lastIndex),
    });
  }

  return (
    <Typography component="div" sx={{ whiteSpace: "pre-wrap" }}>
      {parts.map((part: IMessagePart) =>
        part.type === "link" ? (
          <MessageHyperlink
            sender={message.sender}
            word={part.value}
            key={part.value}
          />
        ) : (
          <React.Fragment key={part.value}>{part.value}</React.Fragment>
        ),
      )}
    </Typography>
  );
};

export default RenderMessage;

const MessageHyperlink = ({
  word,
  sender,
}: {
  word: string;
  sender: "user" | "bot" | "system" | "agent";
}): React.JSX.Element => {
  return (
    <Link
      href={word}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        color:
          sender === "user"
            ? (theme) => theme.palette.widgetStyles.userChatBubble.linkColor
            : (theme) => theme.palette.widgetStyles.botChatBubble.linkColor,

        "&:hover": {
          color:
            sender === "user"
              ? (theme) =>
                  theme.palette.widgetStyles.userChatBubble.linkHoverColor
              : (theme) =>
                  theme.palette.widgetStyles.botChatBubble.linkHoverColor,
        },
      }}
    >
      {word + " "}
      <Box component="span" sx={visuallyHidden}>
        (öffnet in neuem Tab)
      </Box>
    </Link>
  );
};
